import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService, DataService, LangueService, LocalService } from '@app/services';
import { DOCUMENT } from '@angular/common';
import { Alert, Langue } from '@app/models';

import * as _ from 'lodash';
import { first } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  toast = new Alert();

  langues: Langue[] = [];
  langue: Langue;

  utilisateur: any;

  pulse: boolean;
  notif: any;
  newMessage: boolean;

  loading: boolean = false;
  subLang: any; 
  subscriptionLang: any; 
  subscription: any; 
  subCred: any; 
  subscriptionNot: any; 

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private dataService: DataService,
    private langueService: LangueService,
    private localService: LocalService,
    private authenticationService: AuthenticationService
  ) {}

  // Sidebar toggle on hamburger button click
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  // Masquer en fonction du role user
  accessLink(){
    return this.authenticationService.isDealer() || this.authenticationService.isAdmin();
  }

  // Selection de la langue a afficher
  selectLanguage(langue: Langue) {
      this.loading = true;

      // Stockage de la langue
      this.authenticationService.saveAppLanguage(langue.code);

      // Rechargement de la page
      location.reload();
  }

  // Logout
  logout(e: Event) {
    e.preventDefault();
    this.dataService.changeState(true);
    this.authenticationService.logout();
  }

  // Chargement de la liste des langues (source)
  loadLangues() {
    this.langueService.getLangues()
    .pipe(first())
    .subscribe(
        (res) => {
          if (res) {
            this.langues = res;
            if(this.langues){
              //detecter changement dans la langue
              this.subLang = this.authenticationService.currentLangueValue
              .pipe(first())
              .subscribe(
                (subres) => {
                  if(subres) {
                    let lang = this.localService?.getJsonValue('currentLangue');
                    this.langue = _.find(this.langues, ['code', lang]);
                  }
                }
              );
            }
          }
        });
  }

  //subscribe to all events changes
  subData(){
    //detecte changement dans l'utilisateur
    this.subscription = this.authenticationService.currentUserValue
    .pipe(first())
    .subscribe(
      res => {
        if(res) {
          this.utilisateur = res;
        }
      }
    );

    //detecte changement dans le credit
    this.subCred = this.dataService.currentMessage
    .pipe(first())
    .subscribe(
      res => {
        if(res?.pulse) {
          this.pulse = res.pulse;
        }
      }
    );

    //detecte changement dans les notification de messages
    this.subscriptionNot = this.dataService.currentMessage.subscribe(
      res => {
        if(res?.notif) {
          this.notif = res.notif;
        }
      }
    );
  }

  ngOnInit(): void {
    this.loadLangues();
    this.subData();
  }

  ngOnDestroy(): void {
    this.subLang.unsubscribe();
    this.subscription.unsubscribe();
    this.subCred.unsubscribe();
    this.subscriptionNot.unsubscribe();
  }
}